import { ListUl, X } from '@styled-icons/boxicons-regular'
import { useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import styled from 'styled-components/macro'

import SingleImageLightbox from '../entry/lightbox/SingleImageLightbox'
import ImagePreview from '../ui/ImagePreview'
import ListEntry, { Icons, PrimaryText } from '../ui/ListEntry'

const ClickableImage = styled.img`
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`

const PhotoEntry = styled(ListEntry).attrs((props) => ({
  leftIcons: [
    <ListUl size={20} key={1} />,
    <ImagePreview isUploading={props.isUploading} sizePx={48} key={2}>
      <ClickableImage
        src={props.src}
        alt={props.alt}
        $clickable={Boolean(props.$onView)}
        onClick={props.$onView}
      />
    </ImagePreview>,
  ],
  rightIcons: (
    <X size={20} onClick={props.$onDelete} style={{ cursor: 'pointer' }} />
  ),
}))`
  height: 65px;
  padding: 0;
  background-color: ${({ theme }) => theme.background};

  ${Icons} {
    margin-inline-end: 10px;
  }
`

const NewBadge = styled.div.attrs({ children: 'New photo' })`
  display: inline-block;
  background-color: ${({ theme }) => theme.blue};
  color: ${({ theme }) => theme.background};
  border-radius: 0.375em;
  padding: 2px;
`

export const PhotoList = ({ photos, reorderPhoto, removePhoto }) => {
  const [lightboxSrc, setLightboxSrc] = useState(null)

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    reorderPhoto(result.source.index, result.destination.index)
  }

  const entries =
    photos &&
    photos.map(({ id, image, name, isNew, isUploading }, index) => (
      <Draggable key={id} draggableId={`${id}`} index={index}>
        {(provided) => (
          <PhotoEntry
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={provided.draggableProps.style}
            src={image}
            alt={name}
            isUploading={isUploading}
            $onView={image ? () => setLightboxSrc(image) : undefined}
            $onDelete={() => removePhoto(index)}
          >
            <PrimaryText>{isNew && <NewBadge />}</PrimaryText>
            <PrimaryText>{name}</PrimaryText>
          </PhotoEntry>
        )}
      </Draggable>
    ))

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {entries}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <SingleImageLightbox
        src={lightboxSrc}
        onClose={() => setLightboxSrc(null)}
      />
    </div>
  )
}
